var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-delete-account-confirmation"},[(_vm.isDeleteAccountConfirmationStatusFetching)?_c('loading'):_c('delete-account-confirmation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }